import axios from 'axios';

const getParameterByName = (name, url) => {
  if (!url) {
    url = window.location.href;
  }
  name = name.replace(/\[\]]/g, '\\$&');
  const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)', 'i'),
    results = regex.exec(url);
  if (!results) {
    return null;
  }
  if (!results[2]) {
    return '';
  }
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
};

const getQueryString = (object) => {
  const queryArray = [];
  let queryString = '';
  for (const key in object) {
    if (object[key]) {
      // don't add the parameter if null
      queryArray.push(key + '=' + encodeURIComponent(object[key]));
    }
  }
  queryString = queryArray.join('&');
  if (queryArray.length) {
    queryString = '?' + queryString;
  }
  return queryString;
};

const truncate = (str, limit, suffix) => {
  if (typeof str !== 'string') {
    return str;
  }
  if (!str || str.length <= limit) {
    return str;
  }
  suffix = suffix || '';
  return (
    Array.from(str.replace(/^\s+|\s+$/g, ''))
      .slice(0, limit)
      .join('') + suffix
  );
};

const downloadBlob = async (url, fileName) => {
  const res = await axios.get(url, { responseType: 'blob' });
  if (res.status !== 200) {
    throw new Error('download-failed');
  }
  const blob = res.data;
  const objectUrl = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = objectUrl;
  a.download = fileName;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(objectUrl);
};

const stopBack = (e) => {
  const BACK_KEYS = {
    46: true,
    8: true,
  };
  const key = e.which || e.keyCode;
  if (BACK_KEYS[key]) {
    e.stopPropagation();
  }
};

const isExistingShow = (url) => /(acast.com|pippa.io)/g.test(url);

export default {
  getParameterByName,
  getQueryString,
  truncate,
  downloadBlob,
  stopBack,
  isExistingShow,
};
